import {
  MarketingPlanSlotImageStatus,
  MarketingPlanSlotStatus,
  MarketingPlanSlotTextStatus,
} from '@/generated/graphql'
import { KindToType } from '@/modules/contentCreator/creator/enums/KindType'

/**
 * Shared filter body for getScheduledContents and getSavedContents.
 * @param {{
 *   timeRange?: string,
 *   textKinds?: string[],
 *   topics?: string[],
 *   page?: number,
 *   perPage?: number,
 *   isMasterView?: boolean,
 * }} [input]
 */
export function buildContentsTimelineInput({
  timeRange,
  textKinds = [],
  topics = [],
  page = 1,
  perPage,
  isMasterView = false,
} = {}) {
  return {
    timeRange,
    textKinds,
    topics,
    page,
    ...(perPage ? { perPage } : {}),
    isMasterView,
  }
}

function localSchedule(iso) {
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return null
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  return {
    date: `${date.getFullYear()}-${month}-${day}`,
    time: `${hours}:${minutes}`,
  }
}

// Calendar cards use the marketing-plan slot shape. A scheduled post is the same
// card, marked so it is not edited through the plan mutations.
export function scheduledContentToSlot(content) {
  const when = content?.socialMediaPosts?.[0]?.scheduledAt || content?.scheduledAt
  const scheduledLocal = when ? localSchedule(when) : null
  if (!scheduledLocal) return null
  const platform = KindToType[content.textKind] || content.socialMediaPosts?.[0]?.type || ''
  return {
    id: `scheduled:${content.id}`,
    source: 'scheduled',
    platform,
    topicId: content.topicId,
    topicName: content.topicName || '',
    scheduledLocal,
    generatedText: content.text || '',
    textStatus: MarketingPlanSlotTextStatus.Ready,
    imageUrl: content.imagePath || '',
    imageStatus: content.imagePath ? MarketingPlanSlotImageStatus.Ready : null,
    status: MarketingPlanSlotStatus.Approved,
    savedContentId: content.id,
  }
}

export function mergePlanSlotsWithScheduled(planSlots, scheduledContents) {
  const linked = new Set((planSlots || []).map((slot) => slot?.savedContentId).filter(Boolean))
  const extras = (scheduledContents || [])
    .map(scheduledContentToSlot)
    .filter((slot) => slot && !linked.has(slot.savedContentId))
  return [...(planSlots || []), ...extras]
}
